const turkishCharMap = {
    'ı': 'i',
    'İ': 'i',
    'ö': 'o',
    'Ö': 'o',
    'ü': 'u',
    'Ü': 'u',
    'ğ': 'g',
    'Ğ': 'g',
    'ş': 's',
    'Ş': 's',
    'ç': 'c',
    'Ç': 'c',
};

export function normalizeTurkish(str) {
    if (!str) return '';
    return str
        .replace(/[ıİöÖüÜğĞşŞçÇ]/g, char => turkishCharMap[char] || char)
        .toLowerCase();
}

export function turkishFilterBy(option, label, search) {
    const optionText = normalizeTurkish(label);
    const searchText = normalizeTurkish(search);
    return optionText.includes(searchText);
}


